export default __webpack_public_path__ + "static/media/kitchen3-afterG-1920w.b185e922.webp";